<template lang="pug">
  .put-the-cookie-down
    h1
      a(href="https://www.youtube.com/watch?v=rMXLBzy1XNE") Put That Cookie Down!
</template>

<script>

// import VueCookies from "vue-cookies"

export default {
  name: 'WidgetCookie',
  components: {
  },
  data () {
    return {
    }
  },
  mounted () {
    window.addEventListener('message', this.receiveMessage, false)
  },
  computed: {
  },
  methods: {
    receiveMessage (event) {
      console.log(event)
      let data = event.data
      $cookies.set('__fw_token', data.token, null, null, 'feature.watch')
    }
  }
}

</script>

<style lang="stylus" scoped>
</style>
